import { useNavigate } from "react-router-dom";

const ActivitiesTable = ({ data = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="border rounded-md h-full min-h-0 overflow-hidden">
      <div className="h-full overflow-y-auto table-scroll">
        <table className="w-full table-fixed">
          <thead className="bg-light sticky top-0 z-10 border-b border-gray-200">
            <tr>
              <th className="w-[90px] px-3 py-2 text-left text-primary text-sm">Code</th>
              <th className="w-[120px] px-3 py-2 text-left text-primary text-sm">Type</th>
              <th className="w-[220px] px-3 py-2 text-left text-primary text-sm">Name</th>
              <th className="px-3 py-2 text-left text-primary text-sm">Description</th>
              <th className="w-[120px] px-3 py-2 text-left text-primary text-sm">Module Code</th>
              <th className="w-[140px] px-3 py-2 text-left text-primary text-sm">Module</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  className="h-[240px] text-center text-sm text-gray-500"
                >
                  No activities found
                </td>
              </tr>
            ) : (
              data.map((row) => (
                <tr
                  key={row.Id}
                  className="border-b"
                >
                  <td className="px-3 py-2 text-sm">
                    {row.Code}
                  </td>
                  <td className="px-3 py-2 text-sm">
                    {row.Type}
                  </td>

                  <td className="px-3 py-2 text-sm">
                    <div className="multi-line-ellipsis" title={row.Name}>
                      {row.Name}
                    </div>
                  </td>

                  <td className="px-3 py-2 text-sm text-gray-500">
                    <div
                      className="multi-line-ellipsis"
                      title={row.Description}
                    >
                      {row.Description}
                    </div>
                  </td>

                  <td className="px-3 py-2 text-sm text-center">
                    {row.ModuleCode}
                  </td>

                  <td className="px-3 py-2 text-sm">
                    {row.ModuleName}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActivitiesTable;